export default "__VITE_ASSET__29b88a3a__"